<template>
  <div
    v-if="recommendedProducts"
    class="cross-selling-product-teasers-fi"
  >
    <product-teasers-fi
      :custom-fields="{
        headline: { value: $dict.get('online-Shop.Product-Teaser.Cross-Selling.Headline') },
        productList: { value: recommendedProducts },
        hideContent: { value: true },
      }"
      :light="light"
      is-recommendation
      @product-added="$emit('product-added', $event)"
    />
  </div>
</template>

<script>
import GET_RECOMMENDATIONS from '@/graphql/getRecommendations.gql';
import ProductTeasersFi from '@/pages/product-teasers-fi/ProductTeasersFi.vue';

export default {
  name: 'CrossSellingProductTeasersFi',
  components: {
    ProductTeasersFi,
  },
  props: {
    productIds: {
      type: String,
      required: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['product-added'],
  data() {
    return {
      recommendedProducts: null,
    };
  },
  apollo: {
    getRecommendations: {
      query: GET_RECOMMENDATIONS,
      variables() {
        return {
          factFinderChannel: this.$fischer.factFinderChannel(),
          productIds: this.productIds,
        };
      },
      skip() {
        return !this.productIds?.length;
      },
    },
  },
  watch: {
    productIds(value) {
      if (!value?.length) {
        this.recommendedProducts = null;
      }
    },
    getRecommendations(value) {
      if (value) {
        this.recommendedProducts = value.hits.map((h) => h?.variantValues?.[0]?.id)?.join('|');
      }
    },
  },
};
</script>

<style scoped src="./cross-selling-product-teasers-fi" />
